import styled from 'styled-components';

export const PageWrapper = styled.main`
  max-width: 1200px;
  min-height: 100vh;
  margin-inline: auto;
  padding: 1rem 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

export const Logo = styled.img`
  width: 148px;
  height: 34px;
`;

export const Step = styled.p`
  color: #fff;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  letter-spacing: 0.28px;
`;

export const Slug = styled.p`
  color: #d2ff00;
  text-align: center;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 18.2px */
  letter-spacing: 0.28px;
`;

export const QuizContainer = styled.div`
  width: 100%;
  border: 1px solid #d2ff00;
  border-radius: 4px;
  display: flex;
  padding: 32px 21px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  flex-shrink: 0;
`;

export const Question = styled.h1`
  color: #fff;
  text-align: center;
  font-family: Open Sans;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 36.4px */
  letter-spacing: 0.56px;
`;

export const Options = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;
`;

export const Option = styled.button`
  background: #fff;
  display: flex;
  width: 271px;
  padding-block: 10px;
  justify-content: center;
  align-items: center;
  color: #0d2c54;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  text-transform: uppercase;
  text-decoration: none;
  border: none;
`;
